/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_P2_BeforeInputs */

const es_l7_price_p2_before = /** @type {(inputs: L7_Price_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El `)
};

const gl_l7_price_p2_before = /** @type {(inputs: L7_Price_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O `)
};

const en_l7_price_p2_before = /** @type {(inputs: L7_Price_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The `)
};

/**
* | output |
* | --- |
* | "The" |
*
* @param {L7_Price_P2_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_p2_before = /** @type {((inputs?: L7_Price_P2_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_P2_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_p2_before(inputs)
	if (locale === "en") return en_l7_price_p2_before(inputs)
	return es_l7_price_p2_before(inputs)
});